import React from "react";
import "./PlantationOneCategory.scss";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
import { Link } from "react-router-dom";

const PlantationOneCategory = () => {
  const { documents } = useCollection("m_categories", [
    "status",
    "==",
    "active",
  ]);
  const [showAll, setShowAll] = React.useState(false);

  return (
    <section className="plantation-category-section">
      <div className="floral-bg-overlay"></div>

      <div className="nature-container">
        {/* Header Section */}
        <div className="text-stack">
          <p className="nature-subheading">
            <span>PLANT CATEGORIES</span>
            <span className="nature-subheading__underline"></span>
          </p>
          <h2 className="nature-heading">
            Explore Our Diverse Plant Collection
          </h2>
        </div>

        {/* Category Grid */}
        <div className="category-grid">
          {documents &&
            documents
              .filter(
                (category) =>
                  category.category.toLowerCase() !== "subscription" &&
                        category.source?.toLowerCase() !== "faq" 

              )
              .slice(0, showAll ? documents.length : 8)
              .map((category, index) => (
                <Link
                  to={`/products?category=${encodeURIComponent(
                    category.category
                  )}`}
                  key={index}
                >
                  <div className="category-card">
                    <img
                      className="category-icon"
                      src={category.categoryImgUrl}
                      alt={category.category}
                    />
                    <h3>
                      {category.category.charAt(0).toUpperCase() +
                        category.category.slice(1)}
                    </h3>
                  </div>
                </Link>
              ))}
        </div>

        {/* View More Button (Optional – uncomment if needed) */}
        {/* <button 
          className="view-more-btn" 
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? 'Show Less' : 'View All Categories'}
        </button> */}
      </div>
    </section>
  );
};

export default PlantationOneCategory;
